var _path, _path2, _path3, _path4, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.8006L2 4.07942C2 4.07942 2 4.00209 2.05801 4.00209C2.07356 4.00259 2.08878 4.00678 2.10247 4.01433C2.11617 4.02188 2.12796 4.03257 2.13693 4.04558C2.13693 4.04558 2.13693 6.99383 11.0352 6.99383C16.9139 6.99383 29.6665 7.00903 29.6665 7.00903C29.9028 7.12909 29.8697 8.70944 29.6557 8.81649L7.7464 8.90625H2.13625C2.08094 8.90625 2.00134 8.8662 2.00134 8.80199",
    fill: "#093E59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 23.8006L2 19.0794C2 19.0794 2 19.0021 2.05801 19.0021C2.07356 19.0026 2.08878 19.0068 2.10247 19.0143C2.11617 19.0219 2.12796 19.0326 2.13693 19.0456C2.13693 19.0456 2.13693 21.9938 11.0352 21.9938C16.9139 21.9938 29.6665 22.009 29.6665 22.009C29.9028 22.1291 29.8697 23.7094 29.6557 23.8165L7.7464 23.9062H2.13625C2.08094 23.9062 2.00134 23.8662 2.00134 23.802",
    fill: "#093E59"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.832 7.10565V11.8268C29.832 11.8268 29.832 11.9042 29.774 11.9042C29.7585 11.9037 29.7433 11.8995 29.7296 11.8919C29.7159 11.8844 29.7041 11.8737 29.6951 11.8607C29.6951 11.8607 29.6951 8.91242 20.7968 8.91242C14.9182 8.91242 2.16555 8.89722 2.16555 8.89722C1.92921 8.77716 1.9623 7.19681 2.17634 7.08976L24.0856 7H29.6958C29.7511 7 29.8307 7.04005 29.8307 7.10426",
    fill: "#093E59"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.832 22.1057V26.8268C29.832 26.8268 29.832 26.9042 29.774 26.9042C29.7585 26.9037 29.7433 26.8995 29.7296 26.8919C29.7159 26.8844 29.7041 26.8737 29.6951 26.8607C29.6951 26.8607 29.6951 23.9124 20.7968 23.9124C14.9182 23.9124 2.16555 23.8972 2.16555 23.8972C1.92921 23.7772 1.9623 22.1968 2.17634 22.0898L24.0856 22H29.6958C29.7511 22 29.8307 22.04 29.8307 22.1043",
    fill: "#093E59"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 14.25,
    width: 7,
    height: 2.5,
    rx: 0.5,
    fill: "#093E59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.adfea367c42f815efbfbce00eabcc236.svg";
export { ForwardRef as ReactComponent };